// extracted by mini-css-extract-plugin
export default {"emptyContainer":"ListEmptyComponent_emptyContainer__pRJmb","emptyImage":"ListEmptyComponent_emptyImage__2OiZF","emptyText":"ListEmptyComponent_emptyText__WwyoV"};